import { Component, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { NgbProgressbarModule, NgbDropdownModule, NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../../Model/Combo/combo.service';
import { RegisterExcelFilterComponent } from '../../RegisterExcelFilter/register-excel-filter/register-excel-filter.component';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-pre-onboarding',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, NgbCollapse, LoaderComponent, NgSelectModule],
  templateUrl: './pre-onboarding.component.html',
  styleUrl: './pre-onboarding.component.scss'
})
export class PreOnboardingComponent {
  isDisabled: boolean = false;
  stars = [0, 1, 2, 3, 4] as any;
  EmployeeData = [] as any;
  FilterColumns = [] as any;
  isCollapsed = true;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  Filter = {
    SelectType: 'PreOnBoarding',
    IsDraft: true,
    EmployeeCode: null,
    EmployeeOldCode: null,
    EmpName: null,
    BranchName: null,
    Category: '',
    Ess_CustomSearchFilterId: null,
    FilterValue: null,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private combo: ComboService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    private toast: ToastService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.Filter.Category = this.router.url.split('/')[3];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetData();
    this.ComboLoad('CustomSearch');
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  GetData() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmpRegistration_SearchGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.EmployeeData = Object.values(response.Table)
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        } else {
          this.EmployeeData = Object.values([])
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
    // this.employeeRegistration.EmpRegSelectGetData({ 'SelectType': this.Filter.TabName, 'EmpMasterId': 0, 'IsDraft': this.Filter.IsDaft }).subscribe({
    //   next: (response) => {
    //     this.EmployeeData = Object.values(response.Table)
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //     this.isDisabled = false;
    //   },
    //   complete: () => { },
    //   error: (error) => {
    //     this.isDisabled = false;
    //   },
    // });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': this.Filter.Category, 'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {
        if (Combotype == 'CustomSearch') {
          if (response.ComboLoad) {
            this.FilterColumns = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetEmployeeDumpReport(result: any) {
    this.isDisabled = true;
    this.employeeRegistration.ESS_GetEmployeeDump_newReport(result).subscribe({
      next: (response) => {
        this.common.handleDownload(response, 'Preonbording.xlsx');
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetEmployeeDumpFilter() {
    const modalRef = this.modalService.open(RegisterExcelFilterComponent, { size: 'lg', backdrop: 'static', });
    modalRef.componentInstance.RegistrationType = 'PreOnBoarding';
    modalRef.componentInstance.EmpType = this.Filter.Category;
    modalRef.result.then((result: any) => {
      if (result != null && result != undefined) {
        result.IsDraft = true;
        this.ESS_GetEmployeeDumpReport(result);
      }
    });
  }

   DeleteDraft(element: any) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        // centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Are you Sure want to Delete?'
      modalRef.result.then((result: any) => {
        if (this.common.PageRight.IsDelete) {
          if (result) {
            this.isDisabled = true;
            this.employeeRegistration.ESS_EmpDraftClear({ SelectType: 'D', EmpMasterId: element.EmpMasterId }).subscribe({
              next: (response) => {
                if (response.Error_Code == '723') {
                  this.isDisabled = false
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                       this.GetData()
                    }
                  });
                }
                else {
                  this.isDisabled = false;
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              }
            })
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }).catch(() => {
        this.isDisabled = false
      });
    }
}
